import { TOKEN_KEY } from '@/helper/common/constant';
import pathConfig from '@/helper/pathConfig';
const { LOGIN_PATH } = pathConfig;
// 登陆地址
export const LoginPath = (path: string, title: string) => {
  return `${LOGIN_PATH}/${encodeURIComponent(
    title,
  )}/${TOKEN_KEY}/${encodeURIComponent(path)}?from=32`;
};

// 下载地址
export const DownloadPath = (title: string) => {
  return `${LOGIN_PATH}/download/${encodeURIComponent(title)}`;
};
